// src/components/project/AddProjectForm.jsx
import { useState, useMemo } from 'react';
import api from '../../services/api';

const AddProjectForm = () => {
  const [newProject, setNewProject] = useState({ project_name: '', name_text: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newProject.project_name.trim()) {
      window.showToast('Введите название проекта');
      return;
    }

    setLoading(true);
    try {
      await api.post('/projects', {
        name: newProject.project_name,
        name_text: newProject.name_text,
      });
      setNewProject({ project_name: '', name_text: '' });
      window.showToast('Проект добавлен');
    } catch (err) {
      console.error('Ошибка при добавлении проекта:', err);
    } finally {
      setLoading(false);
    }
  };

  const renderForm = useMemo(() => {
    return (
      <form onSubmit={handleSubmit} className="mb-4 new-project-form">
        <div className="mb-3 new-project">
          <label className="form-label">Название проекта (короткое)</label>
          <input
            type="text"
            className="form-control"
            placeholder="Например: Проект А"
            value={newProject.project_name}
            onChange={(e) => setNewProject({ ...newProject, project_name: e.target.value })}
            required
          />
        </div>
        <div className="mb-3 new-project">
          <label className="form-label">Полное имя проекта</label>
          <input
            type="text"
            className="form-control"
            placeholder="Например: Основной научный проект"
            value={newProject.name_text}
            onChange={(e) => setNewProject({ ...newProject, name_text: e.target.value })}
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Добавление...' : 'Добавить проект'}
        </button>
      </form>
    );
  }, [newProject, loading, handleSubmit]);

  return renderForm;
};

export default AddProjectForm;
